import styles from "./InnerClientLayout.module.scss";

interface InnerClientLayoutProps {
  children: React.ReactNode;
  title?: string;
}

const InnerClientLayout = ({ children, title }: InnerClientLayoutProps) => {
  return (
    <div className={styles.innerClientLayout}>
      {title && (
        <div className={styles.title}>
          <h4>{title}</h4>
        </div>
      )}
      {children}
    </div>
  );
};

export default InnerClientLayout;
